/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/

/**
 * CRA/webpack emits every local `import x from '*.svg'` as a separate,
 * content-hashed static file under /static/media/ — it is NOT inlined into
 * the JS bundle. That means the browser still has to fetch it over the
 * network the first time it's rendered, exactly like a remote branding
 * image. If connectivity drops before a given capture screen has ever been
 * visited this session, that fetch fails and the icon renders broken.
 *
 * These are the bundled icons used on the Instructions and
 * capture (MediaUploader) screens — prefetched eagerly from Capture.jsx
 * alongside the remote branding/reference assets so they're already cached
 * locally by the time any of those screens render, whether or not the
 * browser happened to fetch them on its own first.
 */
import cameraWhiteIcon from '../assets/camera-white.svg';
import cameraIcon from '../assets/camera.svg';
import videoWhiteIcon from '../assets/video-white.svg';
import videoIcon from '../assets/video.svg';
import scannerWhiteIcon from '../assets/scanner-white.svg';
import scannerIcon from '../assets/scanner.svg';
import filesWhiteIcon from '../assets/files-white.svg';
import filesIcon from '../assets/files.svg';
import audioWhiteIcon from '../assets/audio-white.svg';
import audioIcon from '../assets/audio.svg';
import fileAttachedPin from '../assets/file-attached-pin.svg';

export const STATIC_CAPTURE_ICON_URLS = [
  cameraWhiteIcon, cameraIcon,
  videoWhiteIcon, videoIcon,
  scannerWhiteIcon, scannerIcon,
  filesWhiteIcon, filesIcon,
  audioWhiteIcon, audioIcon,
  fileAttachedPin,
];

/**
 * Same problem, different asset: pdfjs's worker script is served from
 * public/ (see PdfInstructionViewer.jsx) rather than bundled, so the
 * browser only fetches it over the network the first time a PDF is
 * actually loaded — including react-pdf's own main-thread fallback if the
 * real Worker fails to start, which re-fetches this exact same URL. If
 * connectivity drops before any PDF (a global instruction, in practice)
 * has ever been opened this session, both paths fail. Prefetched into
 * IndexedDB here for the same reason as the icons above.
 */
export const PDF_WORKER_SRC = '/pdf.worker.min.mjs';
